import { render, staticRenderFns } from "./AtualizarSenha.vue?vue&type=template&id=0d147c80"
import script from "./AtualizarSenha.vue?vue&type=script&lang=js"
export * from "./AtualizarSenha.vue?vue&type=script&lang=js"
import style0 from "./AtualizarSenha.vue?vue&type=style&index=0&id=0d147c80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports